import React from "react";
import { siteData } from "../data/mockData";

const ServicesSection = () => {
  const { services } = siteData;

  return (
    <section
      id="services"
      className="w-full bg-[#FAFAFA] py-16 md:py-24 px-6 md:px-16"
    >
      <div className="max-w-[1400px] mx-auto">
        {/* Section Header */}
        <div className="mb-12">
          <h2 className="font-poppins font-bold text-[2rem] md:text-[2.5rem] text-[#1a1a1a] leading-snug md:leading-tight">
            {services.sectionTitle1}
          </h2>
          <div className="flex items-end mt-4 md:mt-2">
            <h2 className="font-poppins font-bold text-[2rem] md:text-[2.5rem] text-[#D1D776] leading-snug md:leading-tight italic whitespace-nowrap">
              {services.sectionHighlight}
            </h2>
            <div className="flex-1 h-[3px] bg-[#D1D776] ml-4 mb-3" />
            <h3 className="font-poppins font-bold text-[1.8rem] md:text-[2.2rem] text-[#1a1a1a] whitespace-nowrap italic ml-4 hidden md:block leading-snug md:leading-normal">
              {services.sectionTitle2}
            </h3>
          </div>
          <h3 className="font-poppins font-bold text-[1.8rem] text-[#1a1a1a] italic mt-4 md:hidden leading-snug">
            {services.sectionTitle2}
          </h3>
        </div>

        {/* Services Card Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.items.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-xl border border-gray-200 p-6 md:p-8 flex flex-col items-center text-center group hover:shadow-lg hover:border-[#1CA0B9]/30 transition-all duration-300 cursor-default"
            >
              {/* Generated Icon Image */}
              <div className="w-20 h-20 mb-5 flex items-center justify-center">
                <img
                  src={service.iconImg}
                  alt={service.title}
                  className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-300"
                />
              </div>

              {/* Title */}
              <h4 className="font-poppins font-bold text-[#1a1a1a] text-base md:text-lg mb-2">
                {service.title}
              </h4>

              {/* Description */}
              <p className="font-poppins text-[#777] text-sm leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
